angular.module('iqxCore')
.controller('actionDialogPlacementsCtrl', function ($scope, FormSvc, ApplicationSvc, ApiSvc, actionDialogSvc) {
    FormSvc.setOptions($scope,{
        fetchAPI:'callresult/NetOwnerPlacementList?pCompanyID='+$scope.actiondialogparams.linkID+($scope.theRecord.leavedate ? '&pPeriodDate='+moment($scope.theRecord.leavedate).format("YYYY-MM-DD") : ''),
        fetchTarget:'placementlist',
        multiRow:true,
        sliceSize:10
    })

    $scope.getPlacementList=function(){
        return $scope.fetch()
    }

    $scope.filterResults=function(){
        $scope.getPlacementList()
    }

    $scope.openActionDialog=function(PersonID){
        var objToActionDialogue = {
            linkID:PersonID,
            type:'Person'
        }
        actionDialogSvc.show($scope, objToActionDialogue)
    }

    $scope.getPlacementList()
})
